import type { LoadingStatus } from 'components/users/flexlist/FlexList';
import { PARTIAL, READY } from 'components/users/flexlist/FlexList';
import { merge, uniq } from 'lodash-es';
import { normalize } from 'normalizr';
import type { IState } from 'redux/state';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import type { State, UserSummary } from './summaries.types';
import {
  clearSummaries,
  fetchedSummaries,
  initialState,
  summariesListSchema,
  summariesXhrModule,
} from './summaries.types';

const { withXhrStatusReducer } = summariesXhrModule;

export type SummariesState = State;

interface NormalizedSummaries {
  entities: { summaries: Record<number, UserSummary> };
  result: Array<number>;
}

export const reducer = reducerWithInitialState<State>(initialState)
  .caseWithAction(fetchedSummaries, (state, action) => {
    const { payload } = action;
    if (payload?.summaries && payload.summaries.length > 0) {
      const summaries = payload.summaries?.map(summary => {
        const { id, name, email, avatar, ...rest } = summary;
        const previous = state.entities[id] ?? {};
        const { hasAccessToTasks, scope } = payload;
        const status: LoadingStatus = hasAccessToTasks
          ? scope === 'forecasts'
            ? READY
            : PARTIAL
          : READY;

        return {
          ...previous,
          id,
          name,
          email,
          avatar,
          byKey: {
            [payload.key]: { ...rest },
          },
          status,
        };
      });

      const { entities, result }: NormalizedSummaries = normalize(summaries, summariesListSchema);
      const mergedEntities = merge({}, state.entities, entities.summaries);

      return {
        ...state,
        entities: mergedEntities,
        result: uniq([...state.result, ...result]),
      };
    }
    return state;
  })
  .case(clearSummaries, () => {
    return initialState;
  });

const readSummaryEntities = (state: IState) => state.summaries.entities;

export const getSummaryEntities = readSummaryEntities;

export default withXhrStatusReducer(reducer);
